import script from "./Desabonnement.vue?vue&type=script&setup=true&lang=ts"
export * from "./Desabonnement.vue?vue&type=script&setup=true&lang=ts"

import "./Desabonnement.vue?vue&type=style&index=0&id=54a5d826&lang=css"

const __exports__ = script;

export default __exports__